import { render, staticRenderFns } from "./FormCandidate.vue?vue&type=template&id=58cfc3ff"
import script from "./FormCandidate.vue?vue&type=script&lang=js"
export * from "./FormCandidate.vue?vue&type=script&lang=js"
import style0 from "./FormCandidate.vue?vue&type=style&index=0&id=58cfc3ff&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports